import { render, staticRenderFns } from "./workerBatchForm.vue?vue&type=template&id=cd280210&scoped=true&"
import script from "./workerBatchForm.vue?vue&type=script&lang=js&"
export * from "./workerBatchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd280210",
  null
  
)

export default component.exports